module.exports = " <div> <v-header :seller=seller></v-header> <div class=\"tab border-1px\"> <div class=tab-item> <a v-link=\"{path: '/goods'}\">商品</a> </div> <div class=tab-item> <a v-link=\"{path: '/ratings'}\">评论</a> </div> <div class=tab-item> <a v-link=\"{path: '/seller'}\">商家</a> </div> </div> <router-view :seller=seller keep-alive></router-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 73
// module chunks = 1